<template>
  <div class="conference">
    <div class="meetingTitle">今日会议</div>

    <div class="meetingcont">
      <div
        class="meetingbox"
        v-for="item in conferencelisdata"
        @click="getparticulars(item.gid)"
        :key="item.gid"
      >
        <div class="meetingImg">
          <img src="../../assets/metting.png" alt="" />
        </div>
        <div class="meetingRight">
          <div class="meetingHeadline">{{ item.title }}</div>
          <div class="meetingtext">
            发布人：<span>{{ item.username }}</span>
          </div>
          <div class="meetingtext">
            会议时间：<span>{{ item.starttime }}</span>
          </div>
          <div class="meetingtext">
            会议地点：<span class="address">{{ item.address }}</span>
          </div>
        </div>
        <div v-if="item.type !== 1" class="meetingTip">已结束</div>
        <div v-else class="meetingTip" style="color: #009157">待开始</div>
        <i
          v-if="item.isremind === 0 && item.type === 1"
          class="el-icon-alarm-clock imgtip"
        />
      </div>
      <div style="clear: both" />
    </div>
    <div class="meetingTitle">会议行程</div>

    <div class="meetingcont">
      <div class="historybtn" @click="historyclikc">
        历史会议 <i class="el-icon-d-arrow-right" />
      </div>
      <div
        class="meetingbox"
        v-for="item in futurelistdata"
        @click="getparticulars(item.gid)"
        :key="item.gid"
      >
        <div class="meetingImg">
          <img src="../../assets/metting.png" alt="" />
        </div>
        <div class="meetingRight">
          <div class="meetingHeadline">{{ item.title }}</div>
          <div class="meetingtext">
            发布人：<span>{{ item.username }}</span>
          </div>
          <div class="meetingtext">
            会议时间：<span>{{ item.starttime }}</span>
          </div>
          <div class="meetingtext">
            会议地点：<span>{{ item.address }}</span>
          </div>
        </div>
        <div class="meetingTip" style="color: #009157">待开始</div>
      </div>
      <div style="clear: both" />
    </div>

    <el-dialog title="会议详情" :visible.sync="particulars" width="700px">
      <div class="particularsbox">
        <div class="describe">
          <span class="title">会议标题：</span
          ><span class="value">{{ particularsdata.title }}</span>
        </div>
        <div class="describe">
          <div class="describetitle">会议描述:</div>
          <div class="describeValue">{{ particularsdata.content }}</div>
        </div>
        <div class="describe">
          <span class="title">发起人：</span
          ><span class="value">{{ particularsdata.username }}</span>
        </div>
        <div class="describe">
          <span class="title">会议时间：</span
          ><span class="value">{{ particularsdata.starttime }}</span>
        </div>
        <div class="describe">
          <span class="title">会议地点：</span
          ><span class="value">{{ particularsdata.address }}</span>
        </div>
        <div class="describe">
          <span class="title">参会人员：</span
          ><span class="value">{{ particularsdata.depts }}</span>
        </div>
        <div class="wire" />
        <div class="btnbox">
          <el-button
            size="small"
            style="width: 100px"
            @click="particulars = false"
            >取消</el-button
          >
          <el-button
            v-if="particularsdata.type === 1"
            size="small"
            style="width: 100px"
            type="primary"
            @click="modification(particularsdata.gid)"
            >修改</el-button
          >
        </div>
        <div style="clear: both" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import { getFormatDate } from "@/utils/util";
export default {
  data() {
    return {
      particulars: false,
      conferencelisdata: [],
      particularsdata: [],
      futurelistdata: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.conferencelist();
    this.futurelist();
    // this.CHANGE_TYPE();
  },
  methods: {
    ...mapMutations(["AMEND_TYPE"]),
    historyclikc() {
      this.$router.push({ name: "history" });
    },
    modification(gid) {
      this.particulars = false;
      this.AMEND_TYPE(gid);
      this.$router.push({
        name: "sponsor",
      });
    },
    // 今日会议
    async conferencelist() {
      const starttime = getFormatDate().substring(0, 10) + " 00:00:00";
      const endtime = getFormatDate().substring(0, 10) + " 23:59:59";
      try {
        const res = await getServerData(
          APIMAP.MEETING,
          {
            pid: this.userInfo.platformid,
            startTime: starttime,
            endTime: endtime,
          },
          "get"
        );
        console.log("列表", res);
        const data = res.rows;
        const times = new Date(getFormatDate()).getTime();
        data.forEach((item) => {
          const timediff = times - new Date(item.starttime).getTime();
          if (timediff < 0) {
            item.type = 1;
          } else {
            item.type = 2;
          }
        });
        this.conferencelisdata = data;
      } catch (e) {
        console.log(e);
      }
    },
    // 会议详情
    async getparticulars(gid) {
      console.log(APIMAP.MEETING + `/:${gid}`);
      try {
        const res = await getServerData(
          APIMAP.MEETING + `/${gid}`,
          {
            gid: gid,
          },
          "get"
        );
        console.log("详情", res);
        const times = new Date(getFormatDate()).getTime();
        const timediff = times - new Date(res.starttime).getTime();
        if (timediff < 0) {
          res.type = 1;
        } else {
          res.type = 2;
        }
        this.particulars = true;
        this.particularsdata = res;
      } catch (e) {
        console.log(e);
      }
    },
    // 未来会议
    async futurelist() {
      const starttime = getFormatDate().substring(0, 10) + " 23:59:59";
      try {
        const res = await getServerData(
          APIMAP.MEETING,
          {
            pid: this.userInfo.platformid,
            startTime: starttime,
          },
          "get"
        );
        console.log("列表", res);
        const data = res.rows;
        this.futurelistdata = data;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.conference {
  height: calc(100vh - 250px);
  overflow: auto;
  .meetingTitle {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 900;
    color: #394259;
    margin-top: 25px;
  }
  .meetingcont {
    border: 1px solid #e2e5ec;
    padding: 15px;
    margin-top: 15px;
    border-radius: 2px;
    position: relative;
    min-height: 100px;
    .historybtn {
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #99a9ba;
      position: absolute;
      right: 0px;
      top: -25px;
      cursor: pointer;
    }
    .meetingbox {
      width: calc(33.3% - 30px);
      height: 100px;
      float: left;
      padding: 15px;
      overflow: hidden;
      margin-bottom: 5px;
      position: relative;
      // min-width: 340px;
      .meetingImg {
        width: 100px;
        height: 100px;
        float: left;
        margin-right: 18px;
        border-radius: 4px;
      }
      .meetingRight {
        float: left;
        color: #969aa5;
        font-size: 14px;
        width: calc(100% - 118px);
        .meetingHeadline {
          font-family: PingFangSC, PingFangSC-Medium;
          font-size: 14px;
          font-weight: 900;
          color: #2c3a50;
          letter-spacing: 2px;
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .meetingtext {
          margin-top: 4px;
          span {
            color: #38455a;
            display: inline-block;
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            top: 4px;
          }
        }
      }
      .meetingTip {
        position: absolute;
        top: 15px;
        right: 15px;
        color: #0ac386;
        font-size: 14px;
      }
      .imgtip {
        position: absolute;
        bottom: 15px;
        right: 15px;
        color: #ffb431;
        font-size: 14px;
      }
    }
  }
  .particularsbox {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #38455a;
    .title {
      color: #969aa5;
      float: left;
      width: 70px;
    }
    .value {
      color: #38455a;
      margin-left: 15px;
      float: left;
      width: calc(100% - 90px);
      letter-spacing: 1px;
      font-size: 14px;
    }
    .describe {
      overflow: hidden;
      margin-top: 15px;
      font-size: 14px;
      .describetitle {
        letter-spacing: 1px;
        color: #969aa5;
        float: left;
        line-height: 16px;
      }
      .describeValue {
        line-height: 21px;
        float: left;
        width: calc(100% - 90px);
        letter-spacing: 1px;
        margin-left: 20px;
        color: #38455a;
      }
    }
    .wire {
      margin-top: 40px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .btnbox {
      float: right;
      margin-top: 15px;
    }
  }
}
</style>
